import type {
  AccountCashOverviewQuery,
  AccountCashOverviewResponse,
  CashTransfer,
  CashTransfersResponse,
  CreateCashTransferRequest,
  UpdateCashTransferRequest,
} from "@repo/shared/types";
import { del, get, patch, post } from "../_client";

// QL-287 — account cash overview + planned cash transfers of a flow instance.
const BASE = "/internal/flow-instances";

export function getCashTransfers(instanceId: string) {
  return get<CashTransfersResponse>(`${BASE}/${instanceId}/cash-transfers`);
}

export function createCashTransfer(instanceId: string, data: CreateCashTransferRequest) {
  return post<CashTransfer>(
    `${BASE}/${instanceId}/cash-transfers`,
    data satisfies CreateCashTransferRequest,
  );
}

export function updateCashTransfer(transferId: string, data: UpdateCashTransferRequest) {
  return patch<CashTransfer>(
    `${BASE}/cash-transfers/${transferId}`,
    data satisfies UpdateCashTransferRequest,
  );
}

export function deleteCashTransfer(transferId: string) {
  return del<{ success: boolean }>(`${BASE}/cash-transfers/${transferId}`);
}

export function getAccountCashOverview(instanceId: string, query: AccountCashOverviewQuery = {}) {
  const params = new URLSearchParams();
  if (query.excludeTransferId) params.set("excludeTransferId", query.excludeTransferId);
  const search = params.size > 0 ? `?${params}` : "";
  return get<AccountCashOverviewResponse>(`${BASE}/${instanceId}/account-cash-overview${search}`);
}
